<template>
    <v-app theme="lightTheme">
        <AppLayout v-if="layout === 'AppLayout'">
            <router-view />
        </AppLayout>
        <router-view v-else />
        <InstallBanner />
    </v-app>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";
import InstallBanner from "@/components/pwa/InstallBanner.vue";
import "@/assets/scss/main.scss";

const route = useRoute();
const layout = computed(() => route.meta.layout);
</script>

<style lang="scss">
html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
}

body {
    font-family: "Roboto", sans-serif;
    background-color: #f5f5f5;
}

#app {
    margin: auto;
    max-width: 600px;
    min-height: 100dvh;
    background-color: #f5f5f5;
}
</style>
